<template>
  <div class="w-full">
    <div class="banner w-full lg:h-80 h-60 relative">
      <div class="flex items-center flex-column w-full h-full">
        <div class="container mx-auto">
          <div class="flex flex-col items-center w-full container lg:items-start">
            <h1 class="text-white font-bold text-2xl md:text-4xl">Welkom bij</h1>
            <h1 class="text-white font-bold text-2xl md:text-4xl">Flavours Broodjes Melsele</h1>
            <div>
              <button-component class="mt-6 mr-6" @click="routeToMenu()">Menu</button-component>
              <button-component class="mt-6" @click="routeToContact()">Contact</button-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import ButtonComponent from '../util/Button.component.vue';

export default defineComponent({
  name: 'Banner-component',
  components: { ButtonComponent },
  setup() {
    const router = useRouter();

    function routeToMenu() {
      router.push('/menu');
    }

    function routeToContact() {
      router.push('/contact');
    }

    return { routeToMenu, routeToContact };
  },
});
</script>
